import React from 'react';
import online1Img from './ReceiverIcon/Frame_14415.svg';
import online2Img from './ReceiverIcon/Frame_14414.svg';
import online3Img from './ReceiverIcon/Frame_14416.svg';
import Accordion from '../../Accordion';

import {
  StyledSubTitleContent,
  StyledMiddleLine,
  StyledSubContent,
  StyledText,
  FlexContainer,
} from './HowToRedeemAccordion';
import { StyledImgWrapper, StyledTitle } from './HowToRedeemViaFairPriceApp';

const steps = [
  {
    image: online1Img,
    title: 'Step 1',
    titleContent: 'Add vouchers at Checkout',
    text: 'Click ‘Add’ next to Voucher code',
  },
  {
    image: online2Img,
    title: 'Step 2',
    titleContent: 'Use your stored vouchers',
    text: 'Select one or more vouchers you would like to use',
  },
];

const props = {
  image: online3Img,
  title: '',
  titleContent: 'Manually enter Voucher code',
  text: 'Copy and paste or enter your code into the ‘Enter voucher code’ field and proceed to checkout',
};

const Card = ({ title, image: img, text, titleContent }) => {
  return (
    <StyledImgWrapper>
      <img alt="img-card" width="160" height="160" loading="eager" src={img.src} />
      <StyledText id="counter-title">
        <StyledTitle>{title}</StyledTitle>
        <StyledSubTitleContent>{titleContent}</StyledSubTitleContent>
        <StyledSubContent>{text}</StyledSubContent>
      </StyledText>
    </StyledImgWrapper>
  );
};
const HowToRedeemOnlineAccordion = () => {
  return (
    <Accordion title="How to redeem online">
      <FlexContainer>
        {steps.map((step, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <Card key={index} {...step} />
        ))}
        <StyledMiddleLine>
          <div className="separator">Or</div>
        </StyledMiddleLine>
        <Card {...props} />
      </FlexContainer>
    </Accordion>
  );
};

export default HowToRedeemOnlineAccordion;
